import { useCreateState } from '../../../../hooks/useCreateState';

type InitialStateType = {
  isVisible: boolean;
  selectedCustomComponentItem: {
    DisplayName: string,
    Name: string,
    Description: string,
  },
}
const initialState: InitialStateType  = {
  isVisible: false,
  selectedCustomComponentItem: {
    DisplayName: '',
    Name: '',
    Description: ''
  },
};

export function useAppState() {
  return useCreateState({
    initialState,
    reducers: {
      show: (state) => ({ ...initialState, isVisible: true }),
      hide: (state) => ({ ...initialState, isVisible: false }),
    },
  });
}
